import React from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  alpha,
  useTheme
} from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const DemoCompletionCTA = ({ onCTAClick, examData, mode, score, questionsCompleted }) => {
  const theme = useTheme();
  
  // Get personalized messaging based on performance (for quiz mode)
  const getPersonalizedMessage = () => {
    if (mode === 'view') {
      return {
        headline: "Ready to ace your HSC?",
        subtext: "Be one of the first to access the full app!",
        ctaText: "Get Early Access",
        icon: <AutoAwesomeIcon sx={{ fontSize: 48, color: theme.palette.primary.main }} />
      };
    }
    
    // Quiz mode - keep it simple too
    return {
      headline: "Ready to ace your HSC?",
      subtext: "Be one of the first to access the full app!",
      ctaText: "Get Early Access",
      icon: <AutoAwesomeIcon sx={{ fontSize: 48, color: theme.palette.primary.main }} />
    };
  };
  
  const { headline, subtext, ctaText, icon } = getPersonalizedMessage();
  
  // Calculate some stats for the CTA
  const totalQuestions = (examData?.questions?.mcq_questions?.length || 0) + 
                        (examData?.questions?.extended_questions?.length || 0);
  const totalMarks = (examData?.questions?.mcq_questions?.length || 0) + 
                    (examData?.questions?.extended_questions?.reduce((sum, q) => sum + (q.marks || 0), 0) || 0);
  
  return (
    <Box sx={{ mt: 4, mb: 4 }}>
      <Paper
        sx={{
          p: 4,
          background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)}, ${alpha(theme.palette.secondary.main, 0.05)})`,
          border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
          borderRadius: 2,
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Icon */}
        <Box sx={{ mb: 2 }}>
          {icon}
        </Box>
        
        {/* Main headline */}
        <Typography 
          variant="h5" 
          sx={{ 
            fontWeight: 600,
            mb: 1,
            color: theme.palette.text.primary
          }}
        >
          {headline}
        </Typography>
        
        {/* Subtext */}
        <Typography 
          variant="body1" 
          sx={{ 
            mb: 3,
            color: theme.palette.text.secondary,
            maxWidth: 400,
            mx: 'auto'
          }}
        >
          {subtext}
        </Typography>
        
        {/* Main CTA button */}
        <Button
          variant="contained"
          size="large"
          startIcon={<AutoAwesomeIcon />}
          onClick={onCTAClick}
          sx={{
            px: 4,
            py: 1.5,
            borderRadius: 3,
            fontWeight: 600,
            fontSize: '1rem',
            textTransform: 'none',
            background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
            boxShadow: theme.shadows[3],
            '&:hover': {
              background: `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
              transform: 'translateY(-2px)',
              boxShadow: theme.shadows[8]
            },
            transition: 'all 0.3s ease'
          }}
        >
          {ctaText}
        </Button>
        
      </Paper>
    </Box>
  );
};

export default DemoCompletionCTA;
